import { Address } from './APIService';

export const formatAddress = ({
  address1,
  address2,
  city,
  state,
  zip
}: Partial<Address>): string[] => {
  const stateZip = [state, zip].filter((v) => v).join(' ');
  const cityState = [city, stateZip].filter((v) => v).join(', ');
  return [address1, address2, cityState].filter((v) => v) as string[];
};
